<template>
  <div class="form-group">
    <vue-slider
      tooltip="false"
      :min="min"
      :max="max"
      step="1"
      :id="id"
      v-model="rangeValue"
      :enableCross="false"
      @input="emit"
    ></vue-slider>
    <label :for="id">{{ rangeValue[0] }} - {{ rangeValue[1] }}</label>
    <div
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>

<script>
import { uniqueId } from "lodash";

export default {
  data() {
    return {
      rangeValue: [0, 1],
      id: uniqueId()
    };
  },
  mounted() {
    if (this.value !== null) {
      this.rangeValue[0] = this.value[0];
      this.rangeValue[1] = this.value[1];
    } else {
      this.rangeValue[0] = Math.round(((this.min + this.max) * 1) / 3);
      this.rangeValue[1] = Math.round(((this.min + this.max) * 2) / 3);
    }
  },
  computed: {
    max() {
      return this.attribute.max;
    },
    min() {
      return this.attribute.min;
    }
  },
  methods: {
    emit() {
      this.$emit("input", {
        min: this.rangeValue[0],
        max: this.rangeValue[1]
      });
    }
  },
  props: {
    value: {
      required: true
    },
    attribute: {
      required: true,
      type: Object
    }
  }
};
</script>
